const arrayMove = (arr, _from, _to) => {
  arr.splice(_to, 0, arr.splice(_from, 1)[0]);
};

const leadingZeroPad = number => (parseInt(number, 10) < 10 ? `0${number}` : number);

const setCookie = (cookieName, cookieValue, nDays = 365) => {
  const d = new Date();
  d.setTime(d.getTime() + (nDays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
};

/* eslint-disable no-plusplus */
const getCookieByName = (cookieName) => {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const getFirstBrowserLanguage = (langs, lang) => {
  const nav = window.navigator;
  const browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
  let i;
  let language;

  if (Array.isArray(nav.languages)) {
    for (i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i];
      const tmp = language.slice(0, 2).toLowerCase();
      if (language && language.length) {
        if (Object.entries(langs).map(item => item[1].symbol.toLowerCase()).includes(tmp)) {
          return language;
        }
        return lang;
      }
    }
  }

  for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]];
    const tmp = language.slice(0, 2).toLowerCase();
    if (language && language.length) {
      if (Object.entries(langs).map(item => item[1].symbol.toLowerCase()).includes(tmp)) {
        return language;
      }
      return lang;
    }
  }

  return null;
};


export {
  arrayMove,
  leadingZeroPad,
  setCookie,
  getCookieByName,
  getFirstBrowserLanguage,
};



// WEBPACK FOOTER //
// ./src/utils/index.js